







































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Image, Post } from '../types'

@Component
export default class Impression extends Vue {
  posts: Post[] = []
  selectedPost: Post | null = null

  get layoutBinding(): { [key: string]: any } {
    const binding: { [key: string]: any } = {}

    if (this.$vuetify.breakpoint.smAndDown) {
      binding.column = true
      binding['px-2'] = true
      binding['py-4'] = true
    } else {
      binding['py-5'] = true
    }

    return binding
  }

  get cardBinding(): { [key: string]: any } {
    const binding: { [key: string]: any } = {}

    if (this.$vuetify.breakpoint.smAndDown) {
      binding['mb-4'] = true
    } else {
      binding['mb-5'] = true
    }

    return binding
  }

  get sizeIsBig(): string {
    if (this.$vuetify.breakpoint.mdAndUp) {
      return 'big'
    }
    return ''
  }

  get selectedPostBinding(): { [key: string]: any } {
    const binding: { [key: string]: any } = {}

    if (this.$vuetify.breakpoint.smAndDown) {
      binding['px-2'] = true
      binding['mb-4'] = true
    } else {
      binding['mb-5'] = true
    }

    return binding
  }

  created(): void {
    fetch('//www.klussenmetkees.nl/wp-json/wp/v2/posts?_embed')
      .then((response: any) => response.json())
      .then((posts: any[]) => {
        this.posts = posts.reverse().map(post => {
          const embedded = post._embedded

          let img: Image | null = null
          const featuredMediaId = post.featured_media
          if (embedded['wp:featuredmedia'] && embedded['wp:featuredmedia'].length) {
            const featuredMedia = embedded['wp:featuredmedia'].filter((fm: any) => fm.id === featuredMediaId)[0]
            img = new Image(
              featuredMedia.title.rendered,
              featuredMedia.alt_text,
              featuredMedia.media_details.sizes.medium.source_url,
              featuredMedia.media_details.sizes.full.source_url,
            )
          }

          const term = embedded['wp:term'] || []
          const tags = (term[1] || []).map((t: any) => t.name)

          return new Post(post.id, post.title.rendered, post.excerpt.rendered, post.content.rendered, tags, img)
        })
      })
      .catch((err: Error) => {
        console.error('could not fetch page', err)
      })
  }

  select(post: Post): void {
    this.selectedPost = post
  }

  deSelect(): void {
    this.selectedPost = null
  }
}
